<script setup lang="ts">
import { computed } from 'vue'
import { userModule } from '@/store/user/module'
import { screenModule } from '@/store/screen/module'

const isDarkMode = computed(() => {
    return userModule.state.settings.isDarkMode
})

const breakpoint = computed(() => {
    return screenModule.getters.getBreakpoint()
})

</script>

<template>
    <div
        v-dark
        class="recall-challenge-card"
    >
        <div v-dark class="recall-challenge-card__title">
            Recall Challenge
        </div>
        <div v-dark class="recall-challenge-card__description">
            A customized set of questions to reinforce everything you've learned on your Level Up Journey.
        </div>
        <div v-dark class="recall-challenge-card__what-to-expect">
            <div v-dark class="recall-challenge-card__what-to-expect-title">
                What to Expect
            </div>
            <ul class="recall-challenge-card__what-to-expect-list">
                <li v-dark class="recall-challenge-card__what-to-expect-list-item">
                    40-70 questions across subjects
                </li>
                <li v-dark class="recall-challenge-card__what-to-expect-list-item">
                    Questions you missed and answered correctly
                </li>
                <li v-dark class="recall-challenge-card__what-to-expect-list-item">
                    Take your challenge as many times as you’d like!
                </li>
            </ul>
        </div>
        <div v-if="breakpoint !== 'black-bear'" class="recall-challenge-card__web-moon-img">
            <img
                v-if="isDarkMode"
                class="recall-challenge-card__dm-moon"
                src="@/assets/levelup/dark-mode/recall-challenge-moon.svg"
                alt=""
            >
            <img
                v-else
                class="recall-challenge-card__dm-moon"
                src="@/assets/levelup/light-mode/recall-challenge-moon.svg"
                alt=""
            >
        </div>
        <div v-else class="recall-challenge-card__mobile-moon-img">
            <img
                v-if="isDarkMode"
                class="recall-challenge-card__dm-moon"
                src="@/assets/levelup/dark-mode/mobile-recall-challenge-moon.svg"
                alt=""
            >
            <img
                v-else
                class="recall-challenge-card__lm-moon"
                src="@/assets/levelup/light-mode/mobile-recall-challenge-moon.svg"
                alt=""
            >
        </div>
    </div>
</template>

<style lang="scss" scoped>
.recall-challenge-card {
    position: relative;
    width: 518px;
    height: 388px;
    border-radius: 5px;
    border: 2px solid $brand-blue;
    background: $white;

    &--dark {
        border: 1px solid $banana-bread;
        background: $brand-black;
    }

    @include breakpoint(black-bear) {
        width: 335px;
        height: 430px;
    }

    &__title {
        color: $brand-black;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        margin: 24px 0 16px 33px;

        &--dark {
            color: $white;
        }

        @include breakpoint(black-bear) {
            margin: 24px 0 16px 24px;
        }
    }

    &__description {
        width: 443px;
        color: $ash;
        font-size: 15px;
        font-weight: 500;
        line-height: 20px;
        margin-left: 33px;
        margin-bottom: 32px;

        &--dark {
            color: $barely-background
        }

        @include breakpoint(black-bear) {
            width: 287px;
            margin-left: 24px;
            margin-bottom: 24px;
        }
    }

    &__what-to-expect {
        width: 458px;
        margin-left: 33px;

        @include breakpoint(black-bear) {
            width: 287px;
            margin-left: 24px;
        }
    }

    &__what-to-expect-title {
        color: $brand-black;
        font-size: 15px;
        font-weight: 600;
        line-height: 20px;
        margin-bottom: 8px;

        &--dark {
            color: $white
        }

        @include breakpoint(black-bear) {
            margin-bottom: 12px;
        }
    }

    &__what-to-expect-list {
        margin: 0;
        padding-left: 20px;
    }

    &__what-to-expect-list-item {
        color: $ash;
        font-size: 15px;
        font-weight: 500;
        line-height: 22px;
        margin-bottom: 2px;

        &--dark {
            color: $barely-background
        }
    }

    &__web-moon-img {
        position: absolute;
        top: -1px;
    }
}
</style>
